import type { IDataFetcher, IDataFetcherFactory } from "app/components/widget/widget-fetchers/IDataFetcher";
import type { IWidget } from "app/components/widget/widget-types/Widget";
import type { ApiParams } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewTraffic/Types";
import { fetchWebsitesFaviconsQuery } from "app/services/sitesService/queries/sitesQueries";
import { getCompareOrganicVSPaid, getMMXTrafficData } from "app/services/WebsiteAnalysis/SearchOverviewApiService";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

interface ITotalVisitsData {
    Data: Record<string, { [key: string]: ChannelBreakdown }>;
}
type Favicons = Record<string, string>;
type ChannelBreakdown = Record<string, number>;

class SearchOrganicPaidOverviewCompareDataFetcherFactory<T> implements IDataFetcherFactory<T> {
    create(widget: IWidget<T>): IDataFetcher<T> {
        const { keys, webSource } = widget.apiParams;
        const isDesktop = webSource === devicesTypes.DESKTOP;

        return {
            async fetch() {
                if (isDesktop) {
                    return await getCompareOrganicVSPaid(widget.apiParams as unknown as ApiParams);
                } else {
                    const [totalVisitsData, favicons]: [ITotalVisitsData, Favicons] = await Promise.all([
                        getMMXTrafficData(widget.apiParams as unknown as ApiParams),
                        fetchWebsitesFaviconsQuery(keys.split(",")),
                    ]);

                    const totalData = totalVisitsData.Data[webSource];
                    const parsedData = Object.entries(totalData).map(([key, value]: [string, ChannelBreakdown]) => {
                        const searchSum = value["Organic Search"] + value["Paid Search"];
                        return {
                            Domain: key,
                            Favicon: favicons[key],
                            OrganicPaidVisits: [value["Organic Search"] / searchSum, value["Paid Search"] / searchSum],
                        };
                    });
                    return { Data: parsedData };
                }
            },
            destroy: () => undefined,
        };
    }
}

export default new SearchOrganicPaidOverviewCompareDataFetcherFactory();
